import React, { useEffect, useRef } from 'react';
import { testimonials } from '../mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 bg-[#efe7cf] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <p className="font-script text-2xl text-[#7a8a4c] mb-2">Stories of healing</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2c3f25] tracking-tight">
            Real journeys, gentle change
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              className="reveal bg-[#f8f3e6] rounded-2xl p-7 md:p-8 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-[#e5dcc0]"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <Quote className="text-[#8fa05a]" size={28} />
              <p className="text-[#3d4a36] mt-4 text-[15px] leading-relaxed italic">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-[#e5dcc0]">
                <p className="font-serif text-lg text-[#2c3f25]">{t.name}</p>
                <p className="text-xs text-[#7a8a4c] mt-1">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
